module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-decoration-bed4743c36c693b5e7c206ef8c76c788.svg";